export class PagedResponse<T> {
  totalCount: number;
  items: Array<T>;

  constructor(init?: Partial<PagedResponse<T>>) {
    Object.assign(this, init);
  }
}
